import Header from "../components/header/Header";
import React  from 'react';
import Body from '../components/body/Body';
import Footer from '../components/footer/Footer';
import './home.scss';

export default function Home(){
    return (
        <>
            <Header/>
            <Body/>
            <Footer/>
        </>
    )
}